type FormatTradeLogicV2ExitCandidateLabelParams = {
    exitCandidateId?: number | null;
    exitCandidateHash?: string | null;
};

export const hasTradeLogicV2ExitCandidateIdentity = ({
    exitCandidateId,
    exitCandidateHash
}: Pick<FormatTradeLogicV2ExitCandidateLabelParams, 'exitCandidateId' | 'exitCandidateHash'>): boolean =>
    exitCandidateId !== null && exitCandidateId !== undefined ? true : Boolean(exitCandidateHash?.trim());

const formatShortHash = (hash: string): string => {
    if (hash.length <= 16) return hash;
    return `${hash.slice(0, 12)}...${hash.slice(-4)}`;
};

export const formatTradeLogicV2ExitCandidateLabel = ({
    exitCandidateId,
    exitCandidateHash
}: FormatTradeLogicV2ExitCandidateLabelParams): string => {
    const normalizedExitCandidateHash = exitCandidateHash?.trim();

    if (exitCandidateId !== null && exitCandidateId !== undefined) {
        return `Candidate ${exitCandidateId}${normalizedExitCandidateHash ? ` (${formatShortHash(normalizedExitCandidateHash)})` : ''}`;
    }

    if (normalizedExitCandidateHash) {
        return `Candidate ${formatShortHash(normalizedExitCandidateHash)}`;
    }

    return 'Base candidate';
};
